module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/RockStars-3fcf74abe672b503297d1543f0b07a3a.png";